import { TiltChartConfigDto, TiltChartDataDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import useReportStore from 'hooks/PracticeReport/Pitcher/reportStore';
import TiltChart from 'components/Charts/TiltChart/TiltChart';

const PracticePitcherSessionTiltChart = (props: ChartProps<TiltChartDataDto, TiltChartConfigDto>) => {
  const { selectedConfgValues } = useReportStore();

  return <TiltChart {...props} pitchGrouping={selectedConfgValues.pitchGrouping} />;
};

export default PracticePitcherSessionTiltChart;
